import React from 'react';
import {
  SInstanceChangeContainer,
  SInstanceChangeTopBar,
  SInstanceListbox,
  SInstanceListboxItem,
} from './styles/InstanceChange.styled';
import Text from '@/presentation/text';
import { useAppDispatch, useAppSelector } from '@/hooks/customHooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons';
import Api from '@/api/helpers';
import { whoAmI } from '@/features/authSlice';
import { useNavigate } from 'react-router-dom';
import { LandingRoute, MessageCenterRoute } from '@/common/routes';
import { fetchCustomers } from '@/features/customersSlice';

interface IProps {
  setVisible: (isVisible: boolean) => void;
}

const basePath = (window as any).CSG_CONFIG.BASE_PATH;
const InstanceChange: React.FC<IProps> = ({ setVisible }) => {
  const availableInstances = useAppSelector((state) => state.auth.availableInstances);
  const { isLoginRedirect } = useAppSelector((state) => state.auth);
  const { isSignedIn, isPassResetRequired, isFetchingWhoAmI } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  return (
    <SInstanceChangeContainer>
      <SInstanceChangeTopBar>
        <Text color="white" size="xs">
          Instance
        </Text>
      </SInstanceChangeTopBar>
      <SInstanceListbox>
        {availableInstances?.map((instance) => {
          return (
            <SInstanceListboxItem
              className="hoverable--dark"
              key={instance.target}
              isSelected={instance.isActive}
              onClick={async () => {
                if (!instance.isActive) {
                  setVisible(false);
                  const client = Api.getAuthClient(dispatch);
                  await client.changeInstance(instance);
                  dispatch(whoAmI());
                  dispatch(fetchCustomers());
                  if (isLoginRedirect && !isFetchingWhoAmI && isSignedIn && !isPassResetRequired) {
                    navigate(`/${basePath}/${MessageCenterRoute}`);
                  } else {
                    navigate(`/${basePath}/${LandingRoute}`);
                  }
                }
              }}
            >
              <Text size="xs">{instance.displayName}</Text>
              {instance.isActive && <FontAwesomeIcon icon={faCheck} />}
            </SInstanceListboxItem>
          );
        })}
      </SInstanceListbox>
    </SInstanceChangeContainer>
  );
};

export default InstanceChange;
